// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"348c709c","683":"75725bb2"}[chunkId] + ".chunk.js";
};